var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgErrorIconLogin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_29_92)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9896 19C11.6376 19 11.3476 18.8757 11.0991 18.6272C10.8506 18.3787 10.7263 18.0888 10.7263 17.7367C10.7263 17.3846 10.8506 17.074 11.0991 16.8462C11.3476 16.5976 11.6376 16.4734 11.9896 16.4734C12.3417 16.4734 12.6316 16.5976 12.8802 16.8462C13.1287 17.0947 13.2529 17.3846 13.2529 17.7367C13.2529 17.9645 13.1908 18.1716 13.0873 18.3787C12.9837 18.5858 12.818 18.7308 12.6316 18.8343C12.4453 18.9586 12.2174 19 11.9896 19Z",
    fill: "#CE082A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1405 5L11.2233 15.0444H12.7766L12.8594 5H11.1405Z",
    fill: "#CE082A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_29_92"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2.54734,
    height: 14,
    fill: "white",
    transform: "translate(10.7263 5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIconLogin);
export default __webpack_public_path__ + "static/media/error-icon-login.0e7fab989e1619c59b17cd5b4a94452b.svg";
export { ForwardRef as ReactComponent };